// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\studios\\\\BookSection\\\\BookSection.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\studios\\BookSection\\BookSection.tsx");
  import.meta.hot.lastModified = "1759417671565.7427";
}
// REMIX HMR END

import { ImageGrid } from "~/components/shared/ImageGrid";
export function BookSection({
  title,
  description,
  data
}) {
  return <section className="relative w-full bg-white">
      <div className="w-full py-12 sm:py-16 lg:py-24">
        {/* Header */}
        <div className="text-center mb-12 px-4 sm:px-6">
          <h2 className="text-3xl lg:text-5xl font-medium uppercase tracking-tight text-[#121212] font-clash-grotesk mb-4">
            {title}
          </h2>
          <p className="text-lg lg:text-xl text-[rgba(18,18,18,0.7)] max-w-2xl mx-auto mb-8">
            {description}
          </p>
        </div>

        {/* Studio Options Grid */}
        <ImageGrid items={data.items} />
      </div>
    </section>;
}
_c = BookSection;
var _c;
$RefreshReg$(_c, "BookSection");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;